import Leaf from 'assets/icons/ios/ios-leaf.svg'

Leaf.displayName = 'Leaf'
export default Leaf
